@if (isInfoMessage()) {
  <p-message severity="info" styleClass="h-full">
    <div class="align-items-baseline flex gap-3">
      <i class="pi pi-info-circle p-message-icon" style="font-size: 1.25rem; margin-top: 0.5rem"></i>

      <div class="flex-1">
        <div class="card justify-content-center flex flex-wrap gap-3">
          <markdown>
            {{ content()?.text }}
          </markdown>
        </div>
      </div>
    </div>
  </p-message>
} @else {
  <markdown appImageZoom [ngClass]="{ 'rounded-md border border-gray-100 bg-gray-100 p-4': isLlmAnswer() }">
    {{ content()?.text }}
  </markdown>
}
